module.exports = __webpack_public_path__ + "@/assets/img/IPP_Logo.3f11def3.png";